var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 440,
    viewBox: "0 0 705 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4216_845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.312 268.155C258.36 268.155 318.389 208.126 318.389 134.077C318.389 60.0284 258.36 0 184.312 0C110.263 0 50.2344 60.0284 50.2344 134.077C50.2344 208.126 110.263 268.155 184.312 268.155Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.121094 32.1926C0.121094 80.9753 30.7248 120.45 68.545 120.45L0.121094 32.1926Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5469 120.45C68.5469 71.1188 102.699 31.201 144.904 31.201L68.5469 120.45Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9141 36.6148C24.9141 82.9532 44.4294 120.45 68.5467 120.45L24.9141 36.6148Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5469 120.45C68.5469 57.4158 108.021 6.4097 156.804 6.4097L68.5469 120.45Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1484 121.072C54.1484 121.072 63.8521 120.773 66.7765 118.69C69.7009 116.608 81.7031 114.121 82.4286 117.461C83.1541 120.801 97.0114 134.072 86.056 134.16C75.1007 134.249 60.6006 132.454 57.6818 130.676C54.763 128.898 54.1484 121.072 54.1484 121.072Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.2554 132.998C75.3001 133.086 60.8001 131.291 57.8813 129.513C55.6584 128.159 54.7727 123.301 54.4763 121.059C54.271 121.068 54.1523 121.072 54.1523 121.072C54.1523 121.072 54.7669 128.898 57.6858 130.676C60.6046 132.454 75.1046 134.249 86.0599 134.16C89.2223 134.135 90.3147 133.01 90.2547 131.343C89.8153 132.35 88.6092 132.979 86.2554 132.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.141 283.224C190.151 283.224 242.852 276.054 242.852 267.21C242.852 258.366 190.151 251.197 125.141 251.197C60.1307 251.197 7.42969 258.366 7.42969 267.21C7.42969 276.054 60.1307 283.224 125.141 283.224Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.139 280.655C179.72 280.655 223.966 274.636 223.966 267.21C223.966 259.785 179.72 253.766 125.139 253.766C70.5588 253.766 26.3125 259.785 26.3125 267.21C26.3125 274.636 70.5588 280.655 125.139 280.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.742 440C625.126 440 704.882 429.15 704.882 415.765C704.882 402.381 625.126 391.531 526.742 391.531C428.358 391.531 348.602 402.381 348.602 415.765C348.602 429.15 428.358 440 526.742 440Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.639 420.881C254.739 420.881 302.649 414.363 302.649 406.323C302.649 398.283 254.739 391.765 195.639 391.765C136.539 391.765 88.6289 398.283 88.6289 406.323C88.6289 414.363 136.539 420.881 195.639 420.881Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.32 394.049C347.973 408.526 456.871 375.165 468.831 337.396",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.012 163.033C195.012 163.033 276.843 140.372 281.879 213.391C286.914 286.409 214.525 307.182 271.178 321.66",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.949 338.204C115.949 338.204 140.544 331.393 142.058 353.339C143.571 375.286 121.814 381.529 138.841 385.88",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.291 354.543L485.333 386.202C485.333 386.202 460.921 399.171 478.085 399.553C495.25 399.934 576.115 399.553 576.115 399.553C576.115 399.553 591.754 399.553 566.96 385.821L562.002 352.636L490.291 354.543Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M474.635 399.209C478.533 395.74 485.335 392.126 485.335 392.126L490.294 360.467L562.004 360.534L566.963 391.745C572.745 394.947 576.326 397.402 578.422 399.285C581.606 398.558 585.086 395.858 566.963 385.821L562.004 352.636L490.294 354.543L485.335 386.202C485.335 386.202 464.822 397.101 474.635 399.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.945 133.881H375.586C369.312 133.881 364.227 138.967 364.227 145.24V347.57C364.227 353.844 369.312 358.93 375.586 358.93H675.945C682.219 358.93 687.304 353.844 687.304 347.57V145.24C687.304 138.967 682.219 133.881 675.945 133.881Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.434 145.897H375.098V314.492H676.434V145.897Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.767 142.464C526.82 142.464 527.674 141.61 527.674 140.556C527.674 139.503 526.82 138.649 525.767 138.649C524.713 138.649 523.859 139.503 523.859 140.556C523.859 141.61 524.713 142.464 525.767 142.464Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.304 327.842V347.57C687.305 349.062 687.011 350.539 686.44 351.917C685.869 353.296 685.033 354.548 683.978 355.603C682.923 356.658 681.671 357.494 680.292 358.065C678.914 358.636 677.437 358.93 675.945 358.93H375.586C374.094 358.93 372.617 358.636 371.239 358.065C369.86 357.494 368.608 356.658 367.553 355.603C366.498 354.548 365.662 353.296 365.091 351.917C364.52 350.539 364.226 349.062 364.227 347.57V327.842H687.304Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.065 420.15V423.965H404.852V420.913L405.134 420.15L410.192 406.418H605.869L610.065 420.15Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.038 416.416C688.664 418.014 687.253 419.7 684.064 421.295C672.621 427.016 649.353 419.769 649.353 419.769C649.353 419.769 631.426 416.717 631.426 408.707C631.929 408.362 632.454 408.05 632.997 407.773C637.808 405.227 653.76 398.947 682.044 408.039C684.128 408.693 685.989 409.912 687.421 411.562C688.567 412.904 689.465 414.605 689.038 416.416Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M689.037 416.416C675.031 421.783 662.546 422.183 649.734 413.284C643.272 408.799 637.402 407.689 632.996 407.773C637.807 405.227 653.759 398.947 682.043 408.039C684.127 408.693 685.988 409.912 687.419 411.562C688.565 412.903 689.464 414.605 689.037 416.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.474 413.284C674.213 413.284 676.433 412.601 676.433 411.759C676.433 410.916 674.213 410.233 671.474 410.233C668.736 410.233 666.516 410.916 666.516 411.759C666.516 412.601 668.736 413.284 671.474 413.284Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.767 350.729C529.769 350.729 533.014 347.484 533.014 343.481C533.014 339.479 529.769 336.234 525.767 336.234C521.764 336.234 518.52 339.479 518.52 343.481C518.52 347.484 521.764 350.729 525.767 350.729Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M610.065 420.15V423.965H404.852V420.913L405.134 420.15H610.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.418 100.086H68.4883V252.418H199.418V100.086Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 84.9785H55.2695V139.113H212.637V84.9785Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 149.185H55.2695V203.319H212.637V149.185Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 213.391H55.2695V267.525H212.637V213.391Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.161 94.4206H171.09V104.492H181.161V94.4206Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M195.642 94.4206H185.57V104.492H195.642V94.4206Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.118 94.4206H200.047V104.492H210.118V94.4206Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.161 157.997H171.09V168.069H181.161V157.997Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M195.642 157.997H185.57V168.069H195.642V157.997Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.118 157.997H200.047V168.069H210.118V157.997Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.161 221.574H171.09V231.645H181.161V221.574Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M195.642 221.574H185.57V231.645H195.642V221.574Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.118 221.574H200.047V231.645H210.118V221.574Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.416 388.383C226.88 388.383 249.144 366.119 249.144 338.655C249.144 311.191 226.88 288.927 199.416 288.927C171.952 288.927 149.688 311.191 149.688 338.655C149.688 366.119 171.952 388.383 199.416 388.383Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.865 377.682H176.758V404.75H191.865V377.682Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08 377.682H206.973V404.75H222.08V377.682Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.347 409.785C196.3 409.785 201.937 407.672 201.937 405.064C201.937 402.457 196.3 400.343 189.347 400.343C182.394 400.343 176.758 402.457 176.758 405.064C176.758 407.672 182.394 409.785 189.347 409.785Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.562 409.156C226.515 409.156 232.151 407.042 232.151 404.435C232.151 401.828 226.515 399.714 219.562 399.714C212.609 399.714 206.973 401.828 206.973 404.435C206.973 407.042 212.609 409.156 219.562 409.156Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.675 343.062C210.062 343.062 217.671 335.452 217.671 326.066C217.671 316.679 210.062 309.07 200.675 309.07C191.289 309.07 183.68 316.679 183.68 326.066C183.68 335.452 191.289 343.062 200.675 343.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.677 331.731C203.806 331.731 206.342 329.195 206.342 326.066C206.342 322.937 203.806 320.401 200.677 320.401C197.548 320.401 195.012 322.937 195.012 326.066C195.012 329.195 197.548 331.731 200.677 331.731Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.18 292.409C147.165 274.427 160.001 256.256 179.849 251.824C199.698 247.392 219.043 258.377 223.058 276.36C227.074 294.342 213.919 300.974 194.071 305.406C174.222 309.838 155.196 310.392 151.18 292.409Z",
    fill: "#FFE8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.056 328.737C258.68 323.334 267.539 315.741 265.843 311.778C264.147 307.814 252.537 308.982 239.913 314.385C227.289 319.788 218.43 327.381 220.126 331.345C221.822 335.308 233.431 334.14 246.056 328.737Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.896 362.099C165.52 356.696 174.379 349.103 172.683 345.14C170.986 341.176 159.377 342.344 146.753 347.747C134.129 353.15 125.27 360.743 126.966 364.707C128.662 368.67 140.271 367.502 152.896 362.099Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.372 353.133C228.372 358 215.84 367.611 201.934 367.611C188.029 367.611 174.867 358.63 174.867 353.763C174.867 348.895 188.029 349.986 201.934 349.986C215.84 349.986 228.372 348.266 228.372 353.133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4216_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 704.761,
    height: 440,
    fill: "white",
    transform: "translate(0.121094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.a2976d570f5acf9635d98f7294921817.svg";
export { ForwardRef as ReactComponent };